var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaqIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C6.954 0 6.154.8 6.154 1.846v3.692c0 1.047.8 1.847 1.846 1.847h3.692l2.462 2.461V7.385c1.046 0 1.846-.8 1.846-1.847V1.846C16 .8 15.2 0 14.154 0H8Zm2.577 1.846h1.057l1.04 3.692h-.924l-.25-.923h-.923l-.23.923h-.809l1.04-3.692Zm.5.616c-.062.246-.13.546-.193.73L10.712 4h.73l-.173-.808c-.123-.184-.192-.484-.192-.73Zm-9.23 3.692C.8 6.154 0 6.954 0 8v3.692c0 1.046.8 1.847 1.846 1.847V16l2.462-2.461H8c1.046 0 1.846-.8 1.846-1.847V8H8c-1.17 0-2.096-.8-2.404-1.846h-3.75Zm2.826 1.788c1.046 0 1.539.862 1.539 1.846 0 .862-.296 1.408-.789 1.655.247.123.538.188.846.25l-.23.615c-.431-.123-.878-.315-1.309-.5-.061-.062-.169-.058-.23-.058-.739-.061-1.423-.673-1.423-1.904 0-1.046.612-1.904 1.596-1.904Zm0 .673c-.492 0-.73.554-.73 1.231 0 .739.238 1.23.73 1.23.493 0 .75-.553.75-1.23 0-.677-.257-1.23-.75-1.23Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faqIcon.4ac0d1f0534b27bea1fa0dc55e987512.svg";
export { ForwardRef as ReactComponent };